import { useState } from 'react';
import { Modal, ModalBody, ModalFooter, Button, ModalHeader } from 'src/components/ui';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { getTestId } from '../../hooks/useTestId';

const PARAMS = ['formData'];

function SendBackModal({
  formData,
  formContext,
  onConfirm: onClose,
  isOpen,
  testIdBase = 'send-back-modal',
}) {
  const {
    setFormDataValues,
  } = formContext;

  const [rejectReason, setRejectReason] = useState('');
  const [error, setError] = useState('');

  function onChange({ target: { value } }) {
    setError('');
    setRejectReason(value);
  }

  function onAccept(e) {
    e.stopPropagation();

    if (!rejectReason) {
      setError(t`You must enter a send-back reason`);
    } else {
      formData.sendBackReason = rejectReason;
      onClose(true);
    }
  }

  return (
    <Modal isOpen={isOpen}
      toggle={() => onClose()}
      className="modal-primary"
      size='xl'
      backdrop
    >
      <ModalHeader
        toggle={() => onClose()}
      >
        <Trans>Send Back Requisition</Trans>
      </ModalHeader>
      <ModalBody>
        <>
          <div className="row">
            <div className="col-lg-12">
              <span className="text-danger">{error}</span>
              <div className="form-group">
                <label className="title"><Trans>Reason*</Trans></label>
                <textarea rows={4} value={rejectReason || ''} className="form-control" name="description" onChange={e => onChange(e)} {...getTestId(testIdBase, '.', 'reason')} />
              </div>
            </div>
          </div>
        </>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onAccept} color="primary" {...getTestId(testIdBase, '.', 'confirm')}>
          <Trans>Confirm</Trans>
        </Button>
        <Button onClick={() => onClose()} color="secondary" {...getTestId(testIdBase, '.', 'close')}>
          <Trans>Close</Trans>
        </Button>
      </ModalFooter>
    </Modal>
  );
}

SendBackModal.PARAMS = PARAMS;

export default SendBackModal;
